import env from 'env/env';

export const isInternal = url => (url !== null && url.startsWith(env.root)) || url === '/';
